<div class="payment-form-container">
  <form #PaymentForm="ngForm">
    <div class="field-row">
      <div class="field">
        <label>Order</label>
        <rms-search-select
          name="OrderID"
          label="Search By Order #"
          [disabled]="IsEdit"
          [options]="OrderOptions"
          labelKey="OrderLabel"
          valueKey="OrderID"
          [required]="true"
          [(ngModel)]="Payment.OrderID">
        </rms-search-select>
        @if (selectedOrderBalance) {
          <div class="order-balance-hint">
            Order Total {{ selectedOrderBalance.OrderTotal | currency }}
            &middot; Paid {{ selectedOrderBalance.OrderPaid | currency }}
            &middot; Balance Due {{ selectedOrderBalance.OrderBalanceDue | currency }}
          </div>
        }
        @if (pendingPaymentsForSelectedOrder.length > 0) {
          <div class="pending-payment-warning">
            <strong>⚠ Already has {{ pendingPaymentsForSelectedOrder.length }} pending payment{{ pendingPaymentsForSelectedOrder.length > 1 ? 's' : '' }} on this order:</strong>
            <ul>
              @for (p of pendingPaymentsForSelectedOrder; track p.OrderPaymentID) {
                <li>{{ p.MethodName }} &middot; {{ p.StatusName }} &middot; {{ p.Amount | currency }}</li>
              }
            </ul>
            If this new payment covers the order, cancel the pending one(s) above first - otherwise it may clear later and result in a double charge.
          </div>
        }
      </div>
      <div class="field">
        <label>Payment Method</label>
        <rms-select
          name="PaymentMethodID"
          [options]="PaymentMethods"
          labelKey="MethodName"
          valueKey="PaymentMethodID"
          [required]="true"
          [(ngModel)]="Payment.PaymentMethodID">
        </rms-select>
      </div>
      <div class="field">
        <label>Status</label>
        <rms-select
          name="StatusID"
          [options]="Statuses"
          labelKey="StatusName"
          valueKey="OrderPaymentStatusID"
          [required]="true"
          [(ngModel)]="Payment.StatusID">
        </rms-select>
      </div>
    </div>

    <div class="field-row">
      <div class="field">
        <label>Amount</label>
        <rms-input name="Amount" type="currency" [required]="true" [(ngModel)]="Payment.Amount" (ngModelChange)="recalculateFee()"></rms-input>
      </div>
      <div class="field">
        <label>Fee %</label>
        <rms-input name="FeePercent" type="percent" [(ngModel)]="Payment.FeePercent" (ngModelChange)="recalculateFee()"></rms-input>
        <span class="field-hint">Typical: 3% for Credit Card</span>
      </div>
      <div class="field">
        <label>Fee Amount</label>
        <rms-input name="FeeAmount" type="currency" [disabled]="true" [(ngModel)]="Payment.FeeAmount"></rms-input>
        <span class="field-hint">Calculated: Amount &times; Fee %</span>
      </div>
    </div>

    <div class="field-row">
      <rms-input name="TransactionReference" label="Transaction Reference" [(ngModel)]="Payment.TransactionReference"></rms-input>
      <div class="field">
        <rms-input name="CardNumberInput" label="Card/Account Number" [(ngModel)]="CardNumberInput"></rms-input>
        <span class="field-hint">
          @if (CardNumberInput) {
            Will be saved as {{ maskedPreview }} - only the last 4 digits are ever stored.
          } @else if (IsEdit && Payment.MaskedReference) {
            Currently on file: {{ Payment.MaskedReference }}. Leave blank to keep it, or type a new number to replace it.
          } @else {
            Type the full number - only the last 4 digits are ever saved.
          }
        </span>
      </div>
    </div>

    @if (isAchPull) {
      <fieldset class="rms-fieldset">
        <legend>ACH Authorization</legend>
        <div class="field-row">
          <rms-input name="AuthorizationRecipientEmail" label="Authorization Recipient Email" [required]="true" [(ngModel)]="Payment.AuthorizationRecipientEmail"></rms-input>
        </div>
        <p class="field-hint">Authorization request will be sent to this email.</p>
      </fieldset>
    } @else {
      <div class="field-row">
        <rms-input name="AuthorizationRecipientEmail" label="Authorization Recipient Email" [(ngModel)]="Payment.AuthorizationRecipientEmail"></rms-input>
      </div>
    }

    <div class="field-row">
      <rms-textarea name="Notes" label="Notes" [(ngModel)]="Payment.Notes"></rms-textarea>
    </div>
  </form>

  <div class="button-container">
    @if (isAchPull) {
      <button mat-button class="btn-bg-blue" [disabled]="!isValid" (click)="saveAndSendAuthorization()">Save & Send Authorization</button>
    }
    <button mat-button class="btn-bg-green" [disabled]="!isValid" (click)="save()">Save</button>
    <button mat-button class="btn-bg-red" (click)="cancel()">Cancel</button>
  </div>
</div>
